<div>
  <ng-template (hostEvent)="onHostEvent($event)" contentHost></ng-template>
</div>
